import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useDagTableStore } from '@/stores/useDagTableStore'
import { queryKeys } from '@/lib/queryKeys'
import { toast } from '@/stores/useToastStore'

const STUCK_THRESHOLD_MS = 30_000
const CHECK_INTERVAL_MS = 5_000

export function useStuckComputingWatcher(
  planId: string | undefined,
  versionId: string | undefined
) {
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!planId || !versionId) return

    const interval = setInterval(() => {
      const { computingStartedAt, reset, triggerSseReconnect } =
        useDagTableStore.getState()

      const now = Date.now()
      const hasStuck = Object.values(computingStartedAt).some(
        ts => now - ts > STUCK_THRESHOLD_MS
      )
      if (!hasStuck) return

      toast.warning(
        'Some updates are taking longer than expected. Refreshing the table.'
      )
      reset()
      queryClient.invalidateQueries({
        queryKey: queryKeys.dagTable.rowsPrefix(planId, versionId),
      })
      triggerSseReconnect()
    }, CHECK_INTERVAL_MS)

    return () => clearInterval(interval)
  }, [planId, versionId, queryClient])
}
